// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TDeleteUserRequestPayload,
  TDeleteUserResponsePayload,
  TGetProjectsWhereAdminRequestPayload,
  TGetProjectsWhereAdminResponsePayload,
  TGetUserDataRequestPayload,
  TGetUserDataResponsePayload,
  TGetUserProjectsRequestPayload,
  TGetUserProjectsResponsePayload,
  TListUsersRequestPayload,
  TListUsersResponsePayload,
  TSaveUserRequestPayload,
  TSaveUserResponsePayload,
  TSetUserDisplayNameRequestPayload,
  TSetUserDisplayNameResponsePayload,
} from './user.types.ts';

export const createUserApi = (transport: TApiTransport) => ({
  /** Removes a person from a project */
  deleteUser: (
    payload: TDeleteUserRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TDeleteUserRequestPayload, TDeleteUserResponsePayload>(
      '/delete_user',
      payload,
      options,
    ),

  /** Lists projects the user administers */
  getProjectsWhereAdmin: (
    payload: TGetProjectsWhereAdminRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetProjectsWhereAdminRequestPayload,
      TGetProjectsWhereAdminResponsePayload
    >('/get_projects_where_admin', payload, options),

  /** Returns the user's data */
  getUserData: (
    payload: TGetUserDataRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TGetUserDataRequestPayload, TGetUserDataResponsePayload>(
      '/get_user_data',
      payload,
      options,
    ),

  /** Lists the user's projects */
  getUserProjects: (
    payload: TGetUserProjectsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetUserProjectsRequestPayload,
      TGetUserProjectsResponsePayload
    >('/get_user_projects', payload, options),

  /** Lists the people in a project */
  listUsers: (
    payload: TListUsersRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TListUsersRequestPayload, TListUsersResponsePayload>(
      '/list_users',
      payload,
      options,
    ),

  /** Adds a person to a project or changes their role */
  saveUser: (payload: TSaveUserRequestPayload, options?: TApiRequestOptions) =>
    transport.post<TSaveUserRequestPayload, TSaveUserResponsePayload>(
      '/save_user',
      payload,
      options,
    ),

  /** Sets the user's display name */
  setUserDisplayName: (
    payload: TSetUserDisplayNameRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSetUserDisplayNameRequestPayload,
      TSetUserDisplayNameResponsePayload
    >('/set_user_display_name', payload, options),
});
